import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ContactFormModal from './ContactFormModal';

const WhyChooseSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <section data-testid="why-choose-section" className="py-24 sm:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <motion.div
              className="space-y-6"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.1]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Built for teams who can't compromise on privacy.
              </h2>

              <div className="space-y-4 text-slate-500 text-base leading-relaxed">
                <p>
                  Mainstream providers like Gmail and Outlook mine your messages for ad targeting and behavioral profiling. Every email you send feeds their data engine.
                </p>
                <p>
                  Guardifix is different. We designed our platform from the ground up with zero-knowledge encryption, meaning no one — not even our own engineers — can access your content. Your messages stay between you and your recipients, period.
                </p>
              </div>

              <div className="pt-4">
                <button
                  data-testid="why-choose-cta-btn"
                  onClick={() => setIsContactOpen(true)}
                  className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-8 py-3.5 text-base rounded-lg transition-all duration-200 hover:scale-[1.02] shadow-lg shadow-blue-700/20"
                >
                  Protect Your Team Now
                </button>
              </div>
            </motion.div>

            <motion.div
              className="relative"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.15 }}
            >
              <div className="relative overflow-hidden rounded-2xl group">
                <img
                  src="https://images.pexels.com/photos/5475750/pexels-photo-5475750.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="Team collaborating on secure communications"
                  className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105"
                  data-testid="why-choose-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>

              <div className="absolute -bottom-4 -right-4 w-28 h-28 bg-emerald-500 rounded-full filter blur-[60px] opacity-20" />
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-blue-600 rounded-full filter blur-[50px] opacity-20" />
            </motion.div>
          </div>
        </div>
      </section>

      <ContactFormModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
        title="Protect Your Team with Guardifix"
      />
    </>
  );
};

export default WhyChooseSection;
